import { render } from "./px-stage-status-item.vue?vue&type=template&id=52cafc02&scoped=true&ts=true"
import script from "./px-stage-status-item.vue?vue&type=script&lang=ts"
export * from "./px-stage-status-item.vue?vue&type=script&lang=ts"

import "./px-stage-status-item.vue?vue&type=style&index=0&id=52cafc02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cafc02"]])

export default __exports__